import { useContext } from 'react'

import { CountersContext } from '../context'

export function useCounters() {
  return useContext(CountersContext)
}
